import { LabelMapper } from 'types';
import { timetableTexts } from 'consts/text';

export const teacherAbsentTypesLabels: LabelMapper<'ABSENT'> = {
    ABSENT: timetableTexts.workingTime.absent,
};
